// extracted by mini-css-extract-plugin
export default {"header":"GeneralErrorPage_header__REvzm","content":"GeneralErrorPage_content__RvKdP"};